import {
  Component,
  EventEmitter,
  HostListener,
  OnDestroy,
  Output,
} from "@angular/core";
import { UserSettingsDrawerDetailsComponent } from "app/shared/components/user-settings-drawer/user-settings-drawer-details/user-settings-drawer-details.component";
import { Subject } from "rxjs";

@Component({
  selector: "user-settings-drawer",
  templateUrl: "./user-settings-drawer.component.html",
  styleUrls: ["./user-settings-drawer.component.scss"],
  imports: [UserSettingsDrawerDetailsComponent],
  standalone: true,
})
export class UserSettingsDrawerComponent implements OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  @Output() public closeUserSettingsDrawer: EventEmitter<void> =
    new EventEmitter<void>();

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  @HostListener("document:keydown.escape", ["$event"])
  public handle(event: KeyboardEvent): void {
    event.stopPropagation();
    this.closeUserSettingsDrawer.emit();
  }
}
